import React from 'react';
import Signup from '../components/SignupComponent/Signup';

function SignupPage() {
  return (
    <div>
      <Signup />
    </div>
  );
}

export default SignupPage;
